module.exports = __webpack_public_path__ + "img/Picture28.001fd8c6.png";